import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/site";

const MotionLink = motion.create(Link);

export const Services = () => {
  return (
    <section id="services" className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--apex-accent)]">What we do</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[var(--apex-primary)] mt-3 leading-tight">
            One crew for every part of your remodel
          </h2>
        </div>
        <p className="text-slate-600 max-w-md">
          From a single bathroom to a full home renovation, Apex handles the structure, the
          finishes, and everything in between.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-12 gap-4">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const hasImg = Boolean(s.image);
          return (
            <MotionLink
              key={s.id}
              to={`/services/${s.id}`}
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className={`group relative text-left overflow-hidden rounded-md border border-slate-200 min-h-[220px] md:col-span-2 ${s.span} ${
                hasImg ? "text-white" : "bg-[var(--apex-surface)]"
              } hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300`}
            >
              {hasImg && (
                <>
                  <img src={s.image} alt={s.title} className="absolute inset-0 h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/30 to-transparent" />
                </>
              )}
              <div className="relative h-full p-6 flex flex-col justify-between">
                <div className={`grid place-items-center h-11 w-11 rounded-sm ${hasImg ? "bg-white/15 backdrop-blur" : "bg-[var(--apex-primary)]"}`}>
                  <Icon size={22} className={hasImg ? "text-white" : "text-white"} />
                </div>
                <div>
                  <div className="flex items-center gap-1.5">
                    <h3 className={`font-display font-bold text-xl ${hasImg ? "text-white" : "text-[var(--apex-primary)]"}`}>{s.title}</h3>
                    <ArrowUpRight size={18} className={`${hasImg ? "text-white" : "text-[var(--apex-accent)]"} opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 -translate-x-1 transition-all`} />
                  </div>
                  <p className={`text-sm mt-1.5 ${hasImg ? "text-slate-200" : "text-slate-600"}`}>{s.blurb}</p>
                </div>
              </div>
            </MotionLink>
          );
        })}
      </div>
    </section>
  );
};
